import { useRef } from 'react'
import { Icon } from '~/components/icon'
import { useChipsContext } from '../../chips'
import {
  ChipsContainer,
  ChipsIcoChecked,
  ChipsVariants,
  RadioButtonVariants,
} from '../../chips.styles'
import type { ChipsProps, ChipsScopedProps } from '../../chips.types'
import { UseChips } from '../../hooks/use-chips'

export const ChipsSingle = (props: ChipsScopedProps<ChipsProps>) => {
  const { __scopeChips, id, name, value, children, onChange } = props
  const {
    size = 'md',
    disabled,
    readOnly,
    checked,
  } = useChipsContext('Chips', __scopeChips)
  const { iconSizeMapping } = UseChips()
  const chipsRef = useRef<HTMLButtonElement>(null)

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled || readOnly) {
      event.preventDefault();
      return;
    }
    if (onChange) {
      onChange();
    }
  }

  return (
    <button
      ref={chipsRef}
      className={ChipsContainer()}
      type="button"
      disabled={disabled || readOnly}
      onClick={handleButtonClick}
      id={id}
      name={name}
      value={value}
    >
      <label
        className={ChipsVariants({
          checked,
          disabled,
          size,
          readOnly,
        })}
        aria-disabled={disabled}
      >
        <input
          type="checkbox"
          className={RadioButtonVariants()}
          id={id}
          disabled={disabled}
          name={name}
          value={value}
          checked={checked}
          readOnly
          tabIndex={-1}
        />
        <span className={ChipsIcoChecked({ size })}>
          <Icon
            size={iconSizeMapping[size]}
            symbol={'rdicon-checkmark'}
            color={
              disabled ? 'colorTextNeutralDisabled' : 'colorTextNeutralDefault'
            }
          />
        </span>
        {children}
      </label>
    </button>
  )
}
